export default {"src":"/_next/static/media/residence-club-logo-alt.f319ceef.svg","height":39,"width":94,"blurWidth":0,"blurHeight":0};